import React from "react";

const Loading = () => {
  return <div>Cargando...</div>;
};

export default Loading;
